import { useState } from 'react';

/** 그룹 이름 최대 길이 — 서버 `GROUP_NAME_MAX_LEN` 과 같은 값. */
export const GROUP_NAME_MAX = 100;
/** ID 항목 이름 최대 길이 — 서버 `ORG_ENTRY_ALIAS_MAX_LEN` 과 같은 값. */
export const ENTRY_ALIAS_MAX = 100;

/**
 * 한 줄 이름 입력(새 그룹 · 하위 그룹 · 이름 변경 공용). Enter = 저장, Esc = 취소.
 * @param initial 처음 값(이름 변경이면 지금 이름)
 */
export function NameForm({
  initial = '',
  placeholder,
  saveLabel = '저장',
  busy,
  onSave,
  onCancel,
}: {
  initial?: string;
  placeholder: string;
  saveLabel?: string;
  busy: boolean;
  onSave: (name: string) => void;
  onCancel: () => void;
}) {
  const [name, setName] = useState(initial);
  const trimmed = name.trim();
  const submit = () => trimmed && onSave(trimmed);
  return (
    <span className="row gtree-form" onClick={(e) => e.stopPropagation()} onDoubleClick={(e) => e.stopPropagation()}>
      <input
        autoFocus
        value={name}
        maxLength={GROUP_NAME_MAX}
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') submit();
          if (e.key === 'Escape') onCancel();
        }}
      />
      <button onClick={submit} disabled={busy || !trimmed}>
        {busy ? '처리 중…' : saveLabel}
      </button>
      <button className="ghost" onClick={onCancel} disabled={busy}>
        취소
      </button>
    </span>
  );
}

/**
 * ID 항목 추가(코드 + 이름) — 조직 공유 항목과 "내 주소록" 이 함께 쓴다.
 * 코드 형식 검사는 서버가 한다(주소록과 같은 규칙) — 여기서는 빈 값만 막는다.
 */
export function EntryForm({
  busy,
  hint,
  onSave,
  onCancel,
}: {
  busy: boolean;
  /** 폼 아래 한 줄 안내(공유 여부 등). */
  hint?: string;
  onSave: (deviceCode: string, alias: string) => void;
  onCancel: () => void;
}) {
  const [code, setCode] = useState('');
  const [alias, setAlias] = useState('');
  const ok = code.trim() && alias.trim();
  const submit = () => ok && onSave(code.trim(), alias.trim());
  const keys = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') submit();
    if (e.key === 'Escape') onCancel();
  };
  return (
    <span className="gtree-form-block" onClick={(e) => e.stopPropagation()} onDoubleClick={(e) => e.stopPropagation()}>
      <span className="row gtree-form">
        <input autoFocus value={code} placeholder="기기 코드 (예: 617-088-148)" aria-label="기기 코드" onChange={(e) => setCode(e.target.value)} onKeyDown={keys} />
        <input value={alias} maxLength={ENTRY_ALIAS_MAX} placeholder="이름" aria-label="이름" onChange={(e) => setAlias(e.target.value)} onKeyDown={keys} />
        <button onClick={submit} disabled={busy || !ok}>
          {busy ? '처리 중…' : '추가'}
        </button>
        <button className="ghost" onClick={onCancel} disabled={busy}>
          취소
        </button>
      </span>
      {hint && <span className="hint">{hint}</span>}
    </span>
  );
}
